'use client';
import type { Assign } from '@ark-ui/react';
import { Progress } from '@ark-ui/react';
import { type ProgressVariantProps, progress } from '@terra/ui-styled-system';
import type { ComponentProps, HTMLStyledProps } from '@terra/ui-styled-system';
import { createStyleContext } from './utils/create-style-context';

const { withProvider, withContext } = createStyleContext(progress);

export type RootProviderProps = ComponentProps<typeof RootProvider>;
export const RootProvider = withProvider<
  HTMLDivElement,
  Assign<
    Assign<HTMLStyledProps<'div'>, Progress.RootProviderProps>,
    ProgressVariantProps
  >
>(Progress.RootProvider, 'root');

export type RootProps = ComponentProps<typeof Root>;
export const Root = withProvider<
  HTMLDivElement,
  Assign<
    Assign<HTMLStyledProps<'div'>, Progress.RootProps>,
    ProgressVariantProps
  >
>(Progress.Root, 'root');

export const Circle = withContext<
  SVGSVGElement,
  Assign<HTMLStyledProps<'svg'>, Progress.CircleProps>
>(Progress.Circle, 'circle');

export const CircleRange = withContext<
  SVGCircleElement,
  Assign<HTMLStyledProps<'circle'>, Progress.CircleRangeProps>
>(Progress.CircleRange, 'circleRange');

export const CircleTrack = withContext<
  SVGCircleElement,
  Assign<HTMLStyledProps<'circle'>, Progress.CircleTrackProps>
>(Progress.CircleTrack, 'circleTrack');

export const Label = withContext<
  HTMLLabelElement,
  Assign<HTMLStyledProps<'label'>, Progress.LabelProps>
>(Progress.Label, 'label');

export const Range = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Progress.RangeProps>
>(Progress.Range, 'range');

export const Track = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Progress.TrackProps>
>(Progress.Track, 'track');

export const ValueText = withContext<
  HTMLSpanElement,
  Assign<HTMLStyledProps<'span'>, Progress.ValueTextProps>
>(Progress.ValueText, 'valueText');

export const View = withContext<
  HTMLSpanElement,
  Assign<HTMLStyledProps<'span'>, Progress.ViewProps>
>(Progress.View, 'view');

export { ProgressContext as Context } from '@ark-ui/react';
